// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {getProviderGamesService} from "../../services/games/gameFeed/providerGames.service";
import {useAuthStore} from "../../store/useAuth.store";

const useGetProviderGames = provider => {
  const authStatus = useAuthStore(state => state.authStatus);
  const isAuthenticated = authStatus === "authenticated";

  const {data, isLoading, isError, error, refetch} = useQuery({
    queryKey: ["providerGames", provider, isAuthenticated],
    queryFn: () => getProviderGamesService(provider, isAuthenticated),
    enabled: !!provider,
    staleTime: 60 * 1000,
  });

  const feedData = data?.data?.data;
  const games = feedData?.games ?? [];
  const total = feedData?.total ?? 0;
  const followerCount = feedData?.follower_count ?? 0;
  const isFollowed = feedData?.is_followed ?? false;

  return {games, total, followerCount, isFollowed, isLoading, isError, error, refetch};
};

export default useGetProviderGames;
